import { render, staticRenderFns } from "./ListNew.vue?vue&type=template&id=efbb1038"
import script from "./ListNew.vue?vue&type=script&lang=js"
export * from "./ListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports